import CrudReducer from './crudReducer';

const cr = new CrudReducer('ai_context');
const aiContextsReducer = cr.Reducer;

export default aiContextsReducer;